import axios from "axios";

import { setupInterceptorsTo } from "./interceptors";

const instance = setupInterceptorsTo(
  axios.create({
    baseURL: import.meta.env.VITE_APP_BACKEND_URL_FC24,
  }),
);

export default instance;

export { getPlayers } from "./publicRequests/players/getPlayers";
export { getPlayStyles } from "./publicRequests/players/getPlayStyles";
export { getTactics } from "./publicRequests/tactics/getTactics";
export { trackTacticUsage } from "./publicRequests/tactics/trackTacticUsage";
export { playerSearchWithMetaRatings } from "./privateRequests/squad-builder/player-search-with-metaRatings";
export { importSquad } from "./privateRequests/squad-builder/import-squad";
export { getMetaRatings } from "./privateRequests/squad-builder/get-meta-ratings";
export { getManagerData } from "./privateRequests/squad-builder/getManagerData";
export { getVersionAssets } from "./privateRequests/players/get-version-assets";
export { getFormations } from "./privateRequests/squad-builder/get-formations";
